import { Link } from 'react-router-dom';
import { Plus, X } from 'lucide-react';
import { MEAL_SLOTS, DAYS_OF_WEEK, formatDate } from './constants';

export const MealGrid = ({ weekDates, meals, recipes, onAdd, onRemove }) => {
  const getRecipeForSlot = (date, mealType) => {
    const key = `${date}_${mealType}`;
    const recipeId = meals[key];
    if (!recipeId) return null;
    return recipes.find((r) => r.id === recipeId);
  };

  return (
    <div className="bg-worldplate-paper rounded-2xl shadow-sm border border-worldplate-border overflow-hidden">
      {/* Header Row */}
      <div className="grid grid-cols-8 border-b border-worldplate-border">
        <div className="p-4 bg-worldplate-subtle" />
        {weekDates.map((date, index) => (
          <div key={date} className="p-4 text-center bg-worldplate-subtle border-l border-worldplate-border">
            <p className="font-medium text-worldplate-deep">{DAYS_OF_WEEK[index]}</p>
            <p className="text-sm text-worldplate-muted">{formatDate(date)}</p>
          </div>
        ))}
      </div>

      {MEAL_SLOTS.map((slot) => (
        <div key={slot.id} className="grid grid-cols-8 border-b border-worldplate-border last:border-b-0">
          <div className="p-4 flex items-center gap-2 bg-worldplate-subtle">
            <slot.icon className="w-5 h-5 text-worldplate-primary" />
            <span className="font-medium text-worldplate-deep text-sm">{slot.label}</span>
          </div>

          {weekDates.map((date) => {
            const recipe = getRecipeForSlot(date, slot.id);
            return (
              <div
                key={`${date}_${slot.id}`}
                className="p-2 border-l border-worldplate-border min-h-[100px]"
              >
                {recipe ? (
                  <div className="relative group h-full">
                    <div className="bg-worldplate-subtle rounded-lg p-2 h-full hover:bg-worldplate-primary/10 transition-colors">
                      <Link to={`/recipes/${recipe.id}`} className="block">
                        <p className="font-medium text-sm text-worldplate-deep line-clamp-2 hover:text-worldplate-primary">
                          {recipe.name}
                        </p>
                        <p className="text-xs text-worldplate-muted mt-1">{recipe.country}</p>
                      </Link>
                    </div>
                    <button
                      onClick={() => onRemove(date, slot.id)}
                      className="absolute -top-1 -right-1 w-5 h-5 bg-worldplate-error text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
                      data-testid={`remove-recipe-${date}-${slot.id}`}
                    >
                      <X className="w-3 h-3" />
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() => onAdd(date, slot.id)}
                    className="w-full h-full min-h-[80px] border-2 border-dashed border-worldplate-border rounded-lg flex items-center justify-center text-worldplate-muted hover:border-worldplate-primary hover:text-worldplate-primary transition-colors"
                    data-testid={`add-recipe-${date}-${slot.id}`}
                  >
                    <Plus className="w-5 h-5" />
                  </button>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default MealGrid;
